import { AlertService, AlertsIconEnum } from "../services/alerts.service";
import translationService from "../services/translator.service";




export const isConnectorHoldingOngoingTransaction = (connector) => {
    const TransactionOperationStateEnum = {
        Pending: 1,
        Success: 2,
        Failure: 3,
        Finished: 4,
        ConfirmedStart: 5,
        DeniedStart: 6,
        ConfirmedStop: 7,
        DeniedStop: 8
    };
    const isConnectorHasTrnsaction = connector?.transaction ? true : false;
    const ongoingStates = [TransactionOperationStateEnum.Pending, TransactionOperationStateEnum.ConfirmedStart];
    const res = isConnectorHasTrnsaction && ongoingStates.includes(connector?.transaction?.transactionStatus)
    return res
}
export const getConnectorStatusDescription = (translatedData, status) => {
    let result;

    if (status) {
        result = translationService.getTranslation(translatedData, 'general.connectorStatuses.' + status);
    }
    else {
        result = translationService.getTranslation(translatedData, 'general.connectorStatuses.Unknown');
    }
    return result;

}
export const getTransactionStatusDescription = (translatedData, status) => {
    let result;
        result = translationService.getTranslation(translatedData, 'general.transactionStatuses.' + status);
    
    return result;
}

export const findChargePoint = (chargerId, isOPU, chargersArray, driverChargersArray, publicChargersArray) => {
    let chargePoint;

    if (isOPU) {
        chargePoint = chargersArray.find(charger => charger.id === chargerId);
    }
    // if the user not operator or the charge point not belong to the user
    if (!chargePoint) {
        chargePoint = driverChargersArray.find(charger => charger.id === chargerId);
    }
    if (!chargePoint) {
        chargePoint = publicChargersArray.find(charger => charger.id === chargerId);
    }
    return chargePoint;
}

export const isActiveChargingStatus = (connector) => {

    const activeStatuses = ['Charging', 'SuspendedEV', 'SuspendedEVSE', 'Finishing'];
    return activeStatuses.includes(connector?.status);
}
export const isSuspendedOrChargingStatus = (connector) => {
    const isConnectorHasTrnsaction = connector?.transaction ? true : false;
    const suspendedOrChargingStatuses = ['Charging', 'SuspendedEV', 'SuspendedEVSE'];
    return isConnectorHasTrnsaction && suspendedOrChargingStatuses.includes(connector?.status);
}

export const isPreparingOrChargingMode = (connector) => {
    const validStatuses = ['Preparing', 'Charging', 'SuspendedEV', 'SuspendedEVSE'];
    return validStatuses.includes(connector?.status);

}

export const findConnectorById = (connectorId, chargePoint ) =>
    chargePoint?.connectors?.find(connector => connector.id === connectorId) || null;

export const findChargePointById = (cpId, chargersArray) => {
    return chargersArray.find(charger => charger.id === cpId) || null;
};

export const userHasPermissionsOnConnector = (userId, chargePoint, connector) => {
    let userHasPermissions = false;

    if (connector?.transaction && isActiveChargingStatus(connector?.status)) {
        userId = userId?.toUpperCase();
        const initiator = connector.transaction.initiator?.initiatorUserId?.toUpperCase();
        const operator = chargePoint.operatorUser?.toUpperCase();
        if (userId === operator || userId === initiator) {
            userHasPermissions = true;
        }
    }
    else {
        userHasPermissions = true;
    }
    return userHasPermissions;
}

/*
 * spec 000251 (Q3-A) — may this user stop the session on this connector? Used ONLY for the stop button and the
 * "not allowed" line; navigation keeps userHasPermissionsOnConnector unchanged (adjacent finding X-3).
 * True when there is no active session, or the session's initiator is unknown (the server decides). Otherwise the
 * initiator or the charger owner, compared case-insensitively. PROD 14 days: every allowed app stop was one of the two.
 */
export const canUserStopSession = (userId, chargePoint, connector) => {
    if (!connector?.transaction || !isActiveChargingStatus(connector)) {
        return true;
    }
    const initiator = connector.transaction.initiator?.initiatorUserId;
    if (!initiator) {
        return true;
    }
    const user = userId?.toUpperCase();
    if (!user) {
        return false;
    }
    return user === initiator.toUpperCase() || user === chargePoint?.operatorUser?.toUpperCase();
}

export const userHasPermissionsOnChargePoint = (authorizedChargersArray, chargerId) => {
    var isUserApprovedOnThisCharger = (authorizedChargersArray.filter(c => c.id === chargerId).length > 0)
    return isUserApprovedOnThisCharger;
}

export const connectorReadyForStartCharging = (connector) => {
    // check if the connector avilable to charging
    let isConnectorReadyToCharge = true;

    if ((connector.status === 'Available' || connector.status === 'Preparing') && connector.transaction) {
        isConnectorReadyToCharge = false;
    }
    return isConnectorReadyToCharge;
}

export const navigateToChargePoint = (history, userId, chargePoint, authorizedChargersArray, translatedData, isPaymentValid) => {
    const isUserApprovedOnThisCharger = userHasPermissionsOnChargePoint(authorizedChargersArray, chargePoint.id);
    // check if user hass permissions on this chargePoint or the chargePoint is public
    if ((!isUserApprovedOnThisCharger && !chargePoint.isPublic)) {
        return;
    }


    if ((!isUserApprovedOnThisCharger && chargePoint.isPublic)) {

        // navigate to connector list screen or connector details screen
        if (!isPaymentValid) {
            AlertService.showMessage(AlertsIconEnum.WARNING, translationService.getTranslation(translatedData, 'messages.mandatoryPaymentMethod'));
            return
        }
    }
    if (chargePoint.connectors.length > 1) {
        history(`/ChargePointStation/Connectors/${chargePoint.id}`);
    }
    else {
        // validate that the user has permissions to this connector
        const hasPermissionsOnConnector = userHasPermissionsOnConnector(userId, chargePoint, chargePoint.connectors[0])
        if (hasPermissionsOnConnector) {
                history(`/ChargePointStation/${chargePoint.id}/connector/${chargePoint.connectors[0].id}`);
        }
        else {
            AlertService.showMessage(AlertsIconEnum.WARNING, translationService.getTranslation(translatedData, 'messages.connectorNotAllowed'));
            return;
        }
    }
}

export const validateChargerIsConnectedAndActiveWithMessages = (translatedData, chargePoint) => {
    if (chargePoint.status !== "Connected") {
        AlertService.showMessage(AlertsIconEnum.ERROR, translationService.getTranslation(translatedData, 'messages.disconnectedCahrger'), { variant: "warning" });
        return false;
    }
    if (!chargePoint.active) {
        AlertService.showMessage(AlertsIconEnum.ERROR, translationService.getTranslation(translatedData, 'messages.inActiveCahrger'), { variant: "info" });
        return false;
    }
    return true;
}

export const isChargePointEqual = (currentChargePoint, previousChargePoint) => {
    // Helper function to safely get chargingDataList length
    const getChargingDataListLength = chargePoint => {
        return (
            chargePoint.connectors?.[0]?.transaction?.transactionDataSummary
                ?.chargingDataList?.length || 0
        );
    };

    // Helper function to deep compare two objects
    const deepEqual = (obj1, obj2) => {
        if (obj1 === obj2) return true;
        if (
            typeof obj1 !== 'object' ||
            typeof obj2 !== 'object' ||
            obj1 === null ||
            obj2 === null
        )
            return false;

        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) return false;

        for (const key of keys1) {
            if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key]))
                return false;
        }

        return true;
    };

    // Compare the entire chargePoint objects (excluding chargingDataList length check)
    const areChargePointsEqual = deepEqual(currentChargePoint, previousChargePoint);

    // Compare lengths of chargingDataList
    const currentLength = getChargingDataListLength(currentChargePoint);
    const previousLength = getChargingDataListLength(previousChargePoint);
    const isChargingDataListLengthChanged = currentLength !== previousLength;

    // Final result: charge points must be identical and the length of chargingDataList must not change
    return areChargePointsEqual && !isChargingDataListLengthChanged;
}   